import update from 'react-addons-update';
import { i18n } from 'core/i18n';
import {
	ACCOUNT_SEARCH_SUCCESS,
	ACCOUNT_CLEAR_ACCOUNT_LIST,
} from './action.js';

const initState = {
	searchResult: [],
	totalCount: 0,
	totalPageCount: 0,
	hasPreviousPage: false,
	hasNextPage: false,
	showSuccessDialog: false
};

export default function accountReducer(state = initState, action) {
	switch (action.type) {
		case ACCOUNT_SEARCH_SUCCESS:
			//帶入編輯用id欄位
			let result = JSON.parse(JSON.stringify(action.data.data.items));
			if (result && result.length > 0) {
				result.forEach(item => {
					item['transcation_data'] = {amt : item.amt, date: item.date, currency: item.currency};
				});
			} else { 
				result.push({ pnr: i18n('no_agent_data')});
			}
			
			return update(state, {
				searchResult: { $set: result },
				totalCount: { $set: action.data.data.totalCount },
				totalPageCount: { $set: action.data.data.totalPageCount },
				hasPreviousPage: { $set: action.data.data.hasPreviousPage },
				hasNextPage: { $set: action.data.data.hasNextPage }
			});
		
		case ACCOUNT_CLEAR_ACCOUNT_LIST:
			return update(state, {
				searchResult: { $set: initState.searchResult },
      });

		default:
			return state;
	}
}